// extracted by mini-css-extract-plugin
export default {"tabs":"LiveUncloakingPage_tabs__pkBeP"};